import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const TabToTop = () => {
  const [BacktoTop, setBacktopTop] = useState("");

  function scroll(ev){
    var st = Math.max(document.documentElement.scrollTop,document.body.scrollTop);
    if (!st){
      setBacktopTop("");
    } else if((st+document.documentElement.clientHeight)>=document.documentElement.scrollHeight ){
      setBacktopTop("d-block");
    }
}

  useEffect(() => {
    // window.addEventListener("scroll", () => {
    //   if (window.scrollY > 100) {
    //     setBacktopTop("d-block");
    //   } else setBacktopTop("");
    // });

    if(window.addEventListener){
      window.addEventListener('scroll',scroll)
    } else if(window.attachEvent){
        window.attachEvent('onscroll',scroll);
    }
  }, []);
  const screenup = () => {
    window.scrollTo({
      // top: 8,
      top: 0,
      behavior: "auto",
      //   smooth
    });
  };
  return (
    <div>
      <Link
        to="#"
        id="back-to-top"
        onClick={screenup}
        className={`${BacktoTop}`}
      >
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"/></svg>
      </Link>
    </div>
  );
};

TabToTop.propTypes = {};

TabToTop.defaultProps = {};

export default TabToTop;
